import { PhoneErrors } from "./types";

export const mapErrorCodes = (code: number): PhoneErrors => {
  switch (code) {
    case 31208:
      return 'nomicpermissions';
    case 31201:
      return 'nomicrophone';
    default:
      return 'unknown';
  }
};
